<template>
  <v-list-item link dense :class="item.IsActive ? '' : 'deactivated'" @click="$emit('click')">
    <v-list-item-icon class="ma-0 my-auto mr-3">
      <v-icon size="20">$unit</v-icon>
    </v-list-item-icon>
    <v-list-item-content class="py-auto">
      <v-list-item-title>
        {{ item.Id }} {{ item.Name }}
      </v-list-item-title>
      <v-list-item-subtitle v-if="item.Description">
        {{ item.Description }}
      </v-list-item-subtitle>
    </v-list-item-content>
  </v-list-item>
</template>


<script>
export default {
  name: 'UnitListItem',
  props: {
    item: Object,
  },
  components: {},

  data() {
    return {};
  },

  methods: {},

  computed: {},

  watch: {},
};
</script>


<style lang='scss'>
.deactivated {
  background-color: var(--v-disabled-lighten1) !important;
}

.deactivated:not(:hover) div div {
  color: var(--v-disabled-darken2) !important;
  text-decoration: line-through !important;
}
</style>